import type { AppointmentSummary } from "@/shared/types/appointment";

/**
 * Order of the "Đã check-in — chờ bắt đầu khám" block (#18602).
 *
 * <p>The patient the doctor has just called in comes first — most recent call on top — and
 * carries a "Đã gọi" mark. Everyone else keeps the appointment-time order. Before this the list
 * put C above B right after B was called, and the only record of who had been called was a toast
 * that had already disappeared.
 */
export function isCalled(a: Pick<AppointmentSummary, "queueState">): boolean {
  return a.queueState === "CALLED";
}

export function orderWaiting<T extends Pick<AppointmentSummary, "queueState" | "calledAt" | "startAt">>(
  rows: readonly T[],
): T[] {
  return [...rows].sort((a, b) => {
    const ca = isCalled(a);
    const cb = isCalled(b);
    if (ca !== cb) return ca ? -1 : 1;
    if (ca && cb) return (b.calledAt ?? "").localeCompare(a.calledAt ?? "");
    return a.startAt.localeCompare(b.startAt);
  });
}
